module.exports = __webpack_public_path__ + "static/media/trainers-back.02823ed8.png";